module.exports = __webpack_public_path__ + "static/practice-02-cover-21b5c74b6c9f3ad7465d5dc1c5deec5a.jpg";